// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__X8PXG","content":"styles_content__3oViT","selectAll":"styles_selectAll__X9lA9"};